<span
  class="d-flex"
  style="align-items: center"
  *ngIf="adOwnerData?.role === 'company'"
>
  <img
    [src]="adOwnerData.logo"
    style="width: 48px; height: 48px; border-radius: 10px; object-fit: cover"
    alt=""
  />
  {{ adOwnerData?.name }}
</span>

<span *ngIf="adOwnerData?.role !== 'company'">
  {{ adOwnerData?.fname }} {{ adOwnerData?.flame }}
</span>
